module.exports = __webpack_public_path__ + "media/images/payments/applepay-dark-7763acf22ded58dc59ac367df76a8b16.svg";